import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const WhitepaperSection = () => {
  return (
    <section className="py-32 px-4 bg-[#05001a] border-y border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-20">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-black mb-8 leading-none uppercase tracking-tighter">
              Whitepaper <span className="text-gradient">Protocol.</span>
            </h2>
            <div className="space-y-6 text-slate-400 text-lg font-light leading-relaxed">
              <p>
                DAI KHO TOKEN (DKT) is the digital asset powering the DAI KHO ecosystem, 
                a community-driven project that combines blockchain technology, spiritual growth, 
                streetwear culture, and Reiki-based services.
              </p>
              <p>
                Built on the XPR Network utilizing BlastPad.io, DKT serves as the foundation 
                for ecosystem participation, staking rewards, and strategic utility across 
                the <span className="text-white font-bold">Dai Kho Limited</span> brand.
              </p>
            </div>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-6">
            {[
              { t: "Sacred Burn", d: "8.91% Total supply permanently removed via 2026 lunar cycle program.", i: "Zap" },
              { t: "Treasury Lock", d: "Founder allocation reduced by 22% and verifiable on-chain.", i: "Shield" },
              { t: "Multi-Pool", d: "Liquidity established across XPR, USDC, and UBQTX pairs.", i: "Activity" },
              { t: "BlastPad Staking", d: "Tiered reward structures for long-term community alignment.", i: "Lock" }
            ].map((item, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="p-8 glass-panel rounded-3xl border-white/5 hover:bg-white/5 transition-colors"
              >
                <div className="w-12 h-12 rounded-xl bg-purple-500/10 flex items-center justify-center mb-6">
                  <SafeIcon name={item.i} className="text-purple-400 w-6 h-6" />
                </div>
                <h4 className="text-white font-bold text-xl mb-2 uppercase tracking-tighter">{item.t}</h4>
                <p className="text-slate-500 text-sm leading-relaxed">{item.d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhitepaperSection;